import { useEffect, useState, createContext } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import DashboardLayout from './pages/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Disputes from './pages/Disputes';
import Pricing from './pages/Pricing';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import Admin from './pages/Admin';
import AdminCompanyDetail from './pages/AdminCompanyDetail';
import { authApi } from './lib/api';

export const AuthContext = createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('infantry_token');
    const saved = localStorage.getItem('infantry_user');
    if (token && saved) {
      setUser(JSON.parse(saved));
      // verify token in background
      authApi.me().then(r => {
        setUser(r.data);
        localStorage.setItem('infantry_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('infantry_token');
        localStorage.removeItem('infantry_user');
        setUser(null);
      });
    }
    setHydrated(true);
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('infantry_user', JSON.stringify(userData));
    if (token) localStorage.setItem('infantry_token', token);
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('infantry_user');
    localStorage.removeItem('infantry_token');
  };

  const Protected = ({ children }) => {
    if (!hydrated) return null;
    if (!user) return <Navigate to="/login" replace />;
    return children;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="disputes" element={<Disputes />} />
              <Route path="billing" element={<Billing />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/companies/:userId" element={<AdminCompanyDetail />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthContext.Provider>
  );
}

export default App;
